export default {
	translation: {},
};
